<mat-toolbar>
  <footer class="layout-container">
    <div class="grid-wrapper">
      <a routerLink="/" tabindex="-1" class="logo" data-testid="footer-logo-link" aria-label="Go to homepage">
        <app-logo/>
      </a>
      <p class="social">
        <app-contact-phone class="mat-title-large"/>
      </p>
      @if (project === "minibank") {
        <p class="example mat-label-large" i18n="footer|Example text @@minibank-example">
          Example: For a loan of 2000 EUR, the loan interest rate is 26.04% per annum, the annual percentage rate is 34.44%. The total amount is 4800.71 EUR,
          paying
          off the loan over seven years, divided into eighty-four equal payments.
        </p>
        <p class="information mat-label-large" i18n="footer|Company information">
          Long company information {{ companyRegistrationNumber }}.
        </p>
        <p class="disclaimer mat-label-large" i18n="footer|Company disclaimer">
          Long company disclaimer.
        </p>
      } @else if (project === "dalidali") {
        <p class="example mat-label-large" i18n="footer|Example text @@dalidali-example">
          Example: For a loan of 2000 EUR, with a loan commission fee of 10%, the loan interest rate is 25.20% per annum, the annual percentage rate is 48.57%. The total repayable amount  will be 2,465.54 EUR.
          If the loan is repaid in twelve installments according to the repayment schedule, the first payment will be 163.11 EUR, including a 100% discount on interest, and each subsequent payment will be EUR 209.31.
        </p>
      } @else {
        <p class="example mat-label-large" i18n="footer|Example text @@finea-example">
            Example: For a loan of 1000 EUR, the loan interest rate is 41.46% per annum, the annual percentage rate is 50.45%. The total amount is 1766.59 EUR,
            paying
            off the loan over three years, divided into thirty-six equal payments.
        </p>
      }
      <p class="block-item info mat-label-large">
        <span>&copy; {{ domain }}, {{ appYear }}</span>
        <span>Skanstes iela 52, Rīga, LV-1013, Latvija</span>
      </p>
      <div class="links">
        @for (item of items; track item.section) {
          <div class="block-item">
            <h2>{{ item.section }}</h2>
            @for (link of item.links; track link.title) {
              <a class="app-link" [routerLink]="link.path" data-testid="footer-app-link">
                <span class="mat-title-medium">{{ link.title }}</span>
              </a>
            }
          </div>
        }
      </div>
    </div>
    <p class="mat-label-large">
      <ng-container i18n="footer|recaptcha-notion">
        This site is protected by reCAPTCHA and the
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" class="app-link">Google Privacy Policy</a>
        and
        <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" class="app-link">Terms of Service</a> apply.
      </ng-container>
    </p>
  </footer>
</mat-toolbar>
